import React, { useEffect, useState } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { useLoginHistory } from "@/features/user/hooks/use-login-history";
import { LoginHistoryResponseModel } from "@/features/user/services/login-history-model";

interface Props {
  onTapCloseModal: () => void;
}

// ログイン履歴モーダル
export const LoginHistoryModal = (props: Props) => {
  const { onTapCloseModal } = props;
  const { getLoginHistory } = useLoginHistory();
  const [loginHistory, setLoginHistory] = useState<LoginHistoryResponseModel[]>([]);

  useEffect(() => {
    const getHistory = async () => {
      const res = await getLoginHistory();
      if (res === undefined) {
        return;
      }
      setLoginHistory(res);
    };

    void getHistory();
  }, []);

  return (
    <BasePageModal
      title="ログイン履歴"
      className="md-user-history"
      handleClose={onTapCloseModal}
    >
      <h2>このアカウントのログイン履歴</h2>
      <div className="wrapper-table">
        <table>
          <thead>
            <tr>
              <th>ログイン日時</th>
              <th>ユーザー名</th>
            </tr>
          </thead>
          <tbody>
            {loginHistory.map((history) => (
              <tr key={`${history.date_time}-${history.user_name}`}>
                <td>{history.date_time}</td>
                <td>{history.user_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </BasePageModal>
  );
}